import { QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'

import { InitialData } from '@/features/auth/domain/initial'
import { Features } from '@/utils/featureFlag/features'

export type RouterContext = {
  isReady?: boolean
  isFeatureEnabled?: (flag: Features) => boolean
  initialData?: InitialData
  queryClient?: QueryClient
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component() {
    return (
      <>
        <Outlet />
        {import.meta.env.DEV ? (
          <>
            <TanStackRouterDevtools />
            <ReactQueryDevtools />
          </>
        ) : null}
      </>
    )
  },
})
